(function (global, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  if (global) global.WvrOneStockConfigurator = api;
  if (typeof document !== 'undefined') api.autoInit();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var READY = 'ready';
  var MISSING_VR = 'missing-vr';
  var MISSING_SYSTEM = 'missing-system';
  var MISSING_MOUNT = 'missing-mount';
  var INVALID = 'invalid';

  function normalizeVrSystem(value) {
    if (value === 'quest-3' || value === 'quest-3s') return 'quest-3-3s';
    var aliases = {'meta-quest-2':'quest-2','meta-quest-3':'quest-3-3s','meta-quest-3s':'quest-3-3s','meta-quest-pro':'quest-pro','ps-vr2':'other','quest-1-rift-s':'other','valve-index':'other','htc-vive':'other','pico-4':'other','hp-reverb-g2':'other'};
    return aliases[value] || value;
  }

  function deriveConfiguration(input) {
    var source = input || {};
    var result = deriveNormalizedConfiguration(Object.assign({}, source, { vrSystem: normalizeVrSystem(source.vrSystem) }));
    if (result.status === READY && (source.vrSystem === 'quest-3' || source.vrSystem === 'quest-3s')) result.vrSystem = source.vrSystem;
    return result;
  }

  function deriveNormalizedConfiguration(input) {
    var state = input || {};
    var isGroupedMeta = state.vrSystem === 'quest-2' || state.vrSystem === 'quest-3-3s' || state.vrSystem === 'quest-pro';
    if (!isGroupedMeta && state.vrSystem !== 'other') {
      return { status: MISSING_VR, missing: 'vr-system', questEligible: false };
    }
    if (state.vrSystem === 'other') {
      if (!state.otherVariantId || !state.basicUrl || !state.basicHandle) {
        return { status: MISSING_SYSTEM, missing: 'other-system', questEligible: false };
      }
      return {
        status: READY,
        missing: null,
        questEligible: false,
        targetHandle: state.otherHandle || state.basicHandle,
        targetUrl: state.otherUrl || state.basicUrl,
        variantId: String(state.otherVariantId),
        vrSystem: 'other',
        mountType: null
      };
    }
    if (state.vrSystem !== 'quest-3-3s') {
      if (!state.basicUrl || !state.basicHandle || !state.basicMetaVariantId) {
        return { status: INVALID, missing: 'vr-system', questEligible: false };
      }
      return {
        status: READY,
        missing: null,
        questEligible: false,
        targetHandle: state.basicHandle,
        targetUrl: state.basicUrl,
        variantId: String(state.basicMetaVariantId),
        vrSystem: state.vrSystem,
        mountType: null
      };
    }
    if (state.magneticEnabled === false) {
      if (!state.basicUrl || !state.basicHandle || !state.basicMetaVariantId) {
        return { status: INVALID, missing: 'vr-system', questEligible: false };
      }
      return {
        status: READY,
        missing: null,
        questEligible: true,
        targetHandle: state.basicHandle,
        targetUrl: state.basicUrl,
        variantId: String(state.basicMetaVariantId),
        vrSystem: 'quest-3-3s',
        mountType: null
      };
    }
    if (state.mountType !== 'non-magnetic' && state.mountType !== 'magnetic') {
      return { status: MISSING_MOUNT, missing: 'mount-type', questEligible: false };
    }
    if (state.mountType === 'magnetic') {
      if (!state.magneticUrl || !state.magneticHandle || !state.magneticVariantId) {
        return { status: INVALID, missing: 'mount-type', questEligible: false };
      }
      return {
        status: READY,
        missing: null,
        questEligible: true,
        targetHandle: state.magneticHandle,
        targetUrl: state.magneticUrl,
        variantId: String(state.magneticVariantId),
        vrSystem: 'quest-3-3s',
        mountType: 'magnetic'
      };
    }
    if (!state.basicUrl || !state.basicHandle || !state.basicMetaVariantId) {
      return { status: INVALID, missing: 'mount-type', questEligible: false };
    }
    return {
      status: READY,
      missing: null,
      questEligible: true,
      targetHandle: state.basicHandle,
      targetUrl: state.basicUrl,
      variantId: String(state.basicMetaVariantId),
      vrSystem: 'quest-3-3s',
      mountType: 'non-magnetic'
    };
  }

  function buildTargetUrl(baseUrl, currentUrl, configuration) {
    if (!baseUrl || !currentUrl || !configuration || configuration.status !== READY) return '';
    try {
      var current = new URL(currentUrl, 'https://example.invalid');
      var target = new URL(baseUrl, current.origin);
      current.searchParams.forEach(function (value, key) {
        if (key !== 'variant' && key !== 'vr_system' && key !== 'mount_type') {
          target.searchParams.append(key, value);
        }
      });
      target.searchParams.set('variant', configuration.variantId);
      target.searchParams.set('vr_system', configuration.vrSystem);
      if (configuration.mountType) target.searchParams.set('mount_type', configuration.mountType === 'non-magnetic' ? 'open-grips' : configuration.mountType);
      return target.pathname + target.search + target.hash;
    } catch (error) {
      return '';
    }
  }

  function readState(root, vrSelect, mountSelect, otherSelect) {
    var otherOption = otherSelect && otherSelect.selectedOptions ? otherSelect.selectedOptions[0] : null;
    return {
      vrSystem: vrSelect ? vrSelect.value : '',
      mountType: mountSelect ? mountSelect.value : '',
      otherVariantId: otherSelect ? otherSelect.value : '',
      otherUrl: otherOption ? otherOption.dataset.url || '' : '',
      otherHandle: otherOption ? otherOption.dataset.productHandle || '' : '',
      magneticEnabled: root.dataset.magneticEnabled === 'true',
      basicUrl: root.dataset.basicUrl || '',
      magneticUrl: root.dataset.magneticUrl || '',
      basicHandle: root.dataset.basicHandle || '',
      magneticHandle: root.dataset.magneticHandle || '',
      basicMetaVariantId: root.dataset.basicMetaVariant || '',
      magneticVariantId: root.dataset.magneticVariant || ''
    };
  }

  function createController(root, doc, win) {
    var scope = root.closest('[data-wvr-onestock-tier-root]') || root.parentElement;
    var vrSelect = root.querySelector('[data-wvr-vr-system]');
    var mountSelect = root.querySelector('[data-wvr-mount-type]');
    var otherSelect = root.querySelector('[data-wvr-other-system]');
    var mountStep = root.querySelector('[data-wvr-mount-step]');
    var otherStep = root.querySelector('[data-wvr-other-step]');
    var statusNode = root.querySelector('[data-wvr-config-status]');
    var form = scope ? scope.querySelector('form.js-main-product-form') : null;
    var current = null;

    function defaultMountType() {
      return root.dataset.magneticEnabled === 'true' && root.dataset.magneticHandle &&
        root.dataset.currentHandle === root.dataset.magneticHandle ? 'magnetic' : '';
    }

    function labelFor(result) {
      if (result.missing === 'vr-system') return root.dataset.labelChooseVr || '';
      if (result.missing === 'other-system') return root.dataset.labelChooseSystem || '';
      if (result.missing === 'mount-type') return root.dataset.labelChooseMount || '';
      return root.dataset.labelAddToCart || '';
    }

    function updatePrimaryActions(result) {
      if (!scope) return;
      var buttons = scope.querySelectorAll('button[name="add"]');
      Array.prototype.forEach.call(buttons, function (button) {
        if (result.status === READY) {
          button.removeAttribute('aria-disabled');
          button.removeAttribute('data-wvr-config-blocked');
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('data-wvr-config-blocked', 'true');
        }
      });
    }

    function publish(result) {
      current = result;
      root.dataset.wvrConfigReady = result.status === READY ? 'true' : 'false';
      root.dataset.wvrQuestEligible = result.questEligible === true ? 'true' : 'false';
      root.dataset.wvrConfigStatus = result.status;
      if (scope) {
        scope.dataset.wvrConfigReady = root.dataset.wvrConfigReady;
        scope.dataset.wvrQuestEligible = root.dataset.wvrQuestEligible;
        scope.dataset.wvrConfigStatus = result.status;
      }
      if (statusNode) statusNode.textContent = labelFor(result);
      updatePrimaryActions(result);
      doc.dispatchEvent(new CustomEvent('wvr:configuration-change', { detail: result }));
      return result;
    }

    function syncSteps() {
      var value = vrSelect ? normalizeVrSystem(vrSelect.value) : '';
      if (mountStep) mountStep.hidden = value !== 'quest-3-3s' || root.dataset.magneticEnabled !== 'true';
      if (otherStep) otherStep.hidden = value !== 'other';
      var hasSecondStep = Boolean((mountStep && !mountStep.hidden) || (otherStep && !otherStep.hidden));
      root.querySelectorAll('[data-wvr-step-number]').forEach(function (number) { number.hidden = !hasSecondStep; });
    }

    function evaluate() {
      syncSteps();
      var result = deriveConfiguration(readState(root, vrSelect, mountSelect, otherSelect));
      // Exploring another setup must not gate purchasing the current Magnetic product.
      if (root.dataset.optionalExploration === 'true') {
        var purchaseState = readState(root, vrSelect, mountSelect, otherSelect);
        purchaseState.vrSystem = 'quest-3-3s';
        purchaseState.mountType = 'magnetic';
        publish(deriveConfiguration(purchaseState));
        return result;
      }
      return publish(result);
    }

    function focusMissing() {
      var target = vrSelect;
      if (current && current.missing === 'mount-type') target = mountSelect;
      if (current && current.missing === 'other-system') target = otherSelect;
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
      if (typeof target.showPicker === 'function') {
        try { target.showPicker(); } catch (error) {}
      } else {
        try { target.click(); } catch (error) {}
      }
    }

    function navigate(result) {
      var target = buildTargetUrl(result.targetUrl, win.location.href, result);
      if (target) win.location.assign(target);
    }

    function chooseAndNavigate() {
      var result = evaluate();
      if (result.status === READY) navigate(result);
    }

    function hydrateFromUrl() {
      var params = new URL(win.location.href).searchParams;
      if (root.dataset.optionalExploration === 'true' && !params.get('vr_system')) {
        vrSelect.value = '';
        if (mountSelect) mountSelect.value = defaultMountType();
        otherSelect.value = '';
        evaluate();
        return current;
      }
      var sourceSystem = params.get('vr_system') || '';
      if (!sourceSystem && defaultMountType() === 'magnetic') sourceSystem = 'quest-3-3s';
      var vrSystem = normalizeVrSystem(sourceSystem);
      var mountType = params.get('mount_type') || '';
      if (mountType === 'open-grips') mountType = 'non-magnetic';
      if (!mountType && (sourceSystem === 'meta-quest-3' || sourceSystem === 'meta-quest-3s')) {
        mountType = root.dataset.currentHandle === root.dataset.magneticHandle ? 'magnetic' : 'non-magnetic';
      }
      if (!mountType) mountType = defaultMountType();
      var variantId = params.get('variant') || '';

      var exactSystem = sourceSystem === 'meta-quest-3s' || sourceSystem === 'quest-3s' ? 'quest-3s' :
        (sourceSystem === 'meta-quest-3' || sourceSystem === 'quest-3' ? 'quest-3' : 'quest-3-3s');
      vrSelect.value = vrSystem === 'quest-3-3s' ? exactSystem : (vrSystem === 'quest-2' || vrSystem === 'quest-pro' || vrSystem === 'other' ? vrSystem : '');
      if (mountSelect) mountSelect.value = (!vrSystem || vrSystem === 'quest-3-3s') && (mountType === 'non-magnetic' || mountType === 'magnetic') ? mountType : '';
      otherSelect.value = vrSystem === 'other' ? variantId : '';

      var result = evaluate();
      if (result.status !== READY) return result;

      var canonicalTarget = buildTargetUrl(result.targetUrl, win.location.href, result);
      var currentTarget = win.location.pathname + win.location.search + win.location.hash;
      if (root.dataset.currentHandle !== result.targetHandle || variantId !== result.variantId || canonicalTarget !== currentTarget) {
        navigate(result);
        return result;
      }

      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      if (variantInput && String(variantInput.value) !== result.variantId) {
        variantInput.value = result.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return result;
    }

    function blockInvalidPurchase(event) {
      if (!current || current.status === READY) return;
      var button = event.target && event.target.closest ? event.target.closest('button[name="add"]') : null;
      if (event.type === 'submit' || button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        focusMissing();
      }
    }

    function bind() {
      vrSelect.addEventListener('change', function () {
        if (mountSelect) mountSelect.value = normalizeVrSystem(vrSelect.value) === 'quest-3-3s' ? (mountSelect.value || defaultMountType()) : '';
        otherSelect.value = '';
        chooseAndNavigate();
      });
      if (mountSelect) mountSelect.addEventListener('change', chooseAndNavigate);
      otherSelect.addEventListener('change', chooseAndNavigate);
      if (scope) scope.addEventListener('click', blockInvalidPurchase, true);
      if (form) form.addEventListener('submit', blockInvalidPurchase, true);
      win.addEventListener('pageshow', function (event) {
        if (event.persisted) hydrateFromUrl();
      });
    }

    root.wvrRequestSelection = focusMissing;
    bind();
    hydrateFromUrl();

    return {
      root: root,
      evaluate: evaluate,
      focusMissing: focusMissing,
      hydrateFromUrl: hydrateFromUrl,
      getConfiguration: function () { return current; }
    };
  }

  function init(doc, win) {
    var targetDoc = doc || document;
    var targetWin = win || window;
    var roots = targetDoc.querySelectorAll('[data-wvr-tier-configurator]');
    return Array.prototype.map.call(roots, function (root) {
      if (root.wvrConfiguratorController) return root.wvrConfiguratorController;
      root.wvrConfiguratorController = createController(root, targetDoc, targetWin);
      return root.wvrConfiguratorController;
    });
  }

  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document, window); });
    } else {
      init(document, window);
    }
  }

  return {
    READY: READY,
    MISSING_VR: MISSING_VR,
    MISSING_SYSTEM: MISSING_SYSTEM,
    MISSING_MOUNT: MISSING_MOUNT,
    INVALID: INVALID,
    deriveConfiguration: deriveConfiguration,
    normalizeVrSystem: normalizeVrSystem,
    buildTargetUrl: buildTargetUrl,
    createController: createController,
    init: init,
    autoInit: autoInit
  };
});

